// Manual horizontal card slider (used in showcases navigation)
(function () {
  function updateSliderArrows(track) {
    if (!track) return;

    var sliderId = track.getAttribute('id');
    if (!sliderId) return;

    var prevBtn = document.querySelector('[data-slider-prev="' + sliderId + '"]');
    var nextBtn = document.querySelector('[data-slider-next="' + sliderId + '"]');

    // A small epsilon avoids flicker due to fractional pixels
    var canScroll = track.scrollWidth > (track.clientWidth + 2);
    var atStart = track.scrollLeft <= 1;
    var atEnd = (track.scrollLeft + track.clientWidth) >= (track.scrollWidth - 1);

    if (prevBtn) prevBtn.style.display = (canScroll && !atStart) ? '' : 'none';
    if (nextBtn) nextBtn.style.display = (canScroll && !atEnd) ? '' : 'none';
    if (canScroll) track.classList.add('is-scrollable');
    else track.classList.remove('is-scrollable');
  }

  function wireArrowUpdates(root) {
    if (!root || root.getAttribute('data-manual-slider-arrows-initialized') === 'true') return;
    root.setAttribute('data-manual-slider-arrows-initialized', 'true');

    // Track is the scroll container
    var track = root.querySelector('[data-slider-track]');
    if (!track) return;

    // Initial state
    updateSliderArrows(track);

    // Update on scroll
    track.addEventListener(
      'scroll',
      function () {
        updateSliderArrows(track);
      },
      { passive: true }
    );

    // Update on resize (bind once per root)
    window.addEventListener('resize', function () {
      updateSliderArrows(track);
    });

    // Update after layout settles (fonts/images)
    window.setTimeout(function () {
      updateSliderArrows(track);
    }, 0);
    window.setTimeout(function () {
      updateSliderArrows(track);
    }, 250);
  }

  function initManualSliders() {
    var rootNodes = document.querySelectorAll('[data-manual-slider]');
    if (!rootNodes || rootNodes.length === 0) return;

    for (var r = 0; r < rootNodes.length; r++) {
      var root = rootNodes[r];

      // Ensure arrow visibility logic is wired
      wireArrowUpdates(root);

      // Avoid double-binding click handler
      if (root.getAttribute('data-manual-slider-initialized') === 'true') continue;
      root.setAttribute('data-manual-slider-initialized', 'true');

      root.addEventListener('click', function (e) {
        var target = e.target;
        if (target && target.closest) target = target.closest('button');
        if (!target) return;

        var nextId = target.getAttribute('data-slider-next');
        var prevId = target.getAttribute('data-slider-prev');
        var trackId = nextId || prevId;
        if (!trackId) return;

        var track = document.getElementById(trackId);
        if (!track) return;

        // Scroll by exactly one card (including gap) to avoid landing on partial cards
        var firstCard = track.querySelector('.card');
        var cardW = firstCard ? firstCard.getBoundingClientRect().width : 260;

        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;

        var step = cardW + gap;
        var direction = nextId ? 1 : -1;
        track.scrollBy({ left: step * direction, top: 0, behavior: 'smooth' });

        // Update arrows shortly after scroll starts
        window.setTimeout(function () {
          updateSliderArrows(track);
        }, 0);
        window.setTimeout(function () {
          updateSliderArrows(track);
        }, 200);
      });
    }
  }

  function boot() {
    initManualSliders();
    setTimeout(initManualSliders, 0);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('turbolinks:load', boot);
  document.addEventListener('page:load', boot);
  document.addEventListener('turbo:load', boot);
})();

// Free search clear (×) button for showcases
(function () {
  function initFreeSearchClear() {
    var input = document.getElementById('free-search-input');
    var clearBtn = document.getElementById('free-search-clear');

    // Not on this page
    if (!input || !clearBtn) return;

    // Avoid double-binding on Turbo/Turbolinks
    if (input.getAttribute('data-free-search-clear-initialized') === 'true') return;
    input.setAttribute('data-free-search-clear-initialized', 'true');

    function toggleClear() {
      if (input.value && input.value.length > 0) {
        clearBtn.classList.remove('d-none');
      } else {
        clearBtn.classList.add('d-none');
      }
    }

    clearBtn.addEventListener('click', function () {
      input.value = '';
      input.focus();
      toggleClear();
    });

    input.addEventListener('input', toggleClear);

    // Initial state
    toggleClear();
  }

  function boot() {
    initFreeSearchClear();
    setTimeout(initFreeSearchClear, 0);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('turbolinks:load', boot);
  document.addEventListener('page:load', boot);
  document.addEventListener('turbo:load', boot);
})();

// Live-update filter dropdown button labels with selected count (before form submit)
(function () {
  function renderSelectedLabel(btn, count) {
    var selectLabel = btn.getAttribute('data-filters-select-label') || 'Select';
    var oneTmpl = btn.getAttribute('data-filters-selected-one') || '%{count} selected';
    var otherTmpl = btn.getAttribute('data-filters-selected-other') || '%{count} selected';

    if (!count || count <= 0) return selectLabel;

    var tmpl = (count === 1) ? oneTmpl : otherTmpl;
    return tmpl.replace('%{count}', String(count));
  }

  function updateButtonForMenu(menu) {
    if (!menu) return;

    var dropdown = menu.closest('.dropdown');
    if (!dropdown) return;

    var btn = dropdown.querySelector('button[data-filters-dropdown-button="true"], button[data-filters-dropdown-button]');
    if (!btn) return;

    var boxes = menu.querySelectorAll('input[type="checkbox"]');
    var count = 0;
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i].checked) count += 1;
    }

    btn.textContent = renderSelectedLabel(btn, count);
  }

  function initLiveFilterCounts(root) {
    var scope = root || document;

    var menus = scope.querySelectorAll('.dropdown-menu');
    for (var i = 0; i < menus.length; i++) {
      // Initial paint (handles preselected via params)
      updateButtonForMenu(menus[i]);

      // Live updates
      menus[i].addEventListener('change', function (e) {
        var target = e.target;
        if (!target) return;
        if (target.matches && target.matches('input[type="checkbox"]')) {
          updateButtonForMenu(this);
        }
      });
    }
  }

  function boot() {
    initLiveFilterCounts(document);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('turbolinks:load', boot);
  document.addEventListener('turbo:load', boot);
})();